import React from 'react';

export const newsletterPagesConfig = [
    {
        auth: ['user'],
        routes: [
            {
                path: '/newsletter',
                component: React.lazy(() => import('./Pages/NewsletterPage')),
            },
        ],
    }
];
